import { QuoteModel, Sensation } from '@bytel/bytel-sales';

import { BasicObject } from '../interfaces/checkout.interface';
import {
    MobileRecoveryCritere,
    MobileRecoveryData,
    MobileRecoveryProduct,
    MobileRecoveryStatus,
} from '../interfaces/mobile-recovery.interface';

export class MobileRecoveryModel {
    public product?: MobileRecoveryProduct;
    public recovery?: MobileRecoveryData;
    public id?: string;
    public status?: MobileRecoveryStatus;
    public step?: string;
    public iban?: string;

    public constructor(data: Partial<MobileRecoveryModel>) {
        Object.assign(this, data);
    }

    public isStarted(): boolean {
        return this.status ? this.status !== MobileRecoveryStatus.UNSTARTED : false;
    }

    public hasEstimation(): boolean {
        return this.recovery ? this.recovery.hasOwnProperty('estimation') : false;
    }

    public isCompleted(): boolean {
        return this.status ? this.status === MobileRecoveryStatus.COMPLETED : false;
    }

    public getApiProduct(): BasicObject {
        const recoveryProduct: BasicObject = {
            gencode: 'RMBC000000',
            sku: 'RMBC000000',
            idUnique: this.id,
            montantEstimeReprise: this.recovery?.estimation?.amount,
            montantBonus: this.product?.bonus,
            type_id: 'mobile-take-back',
            imei: this.recovery.criterias?.imei,
            idDevisPartenaire: this.recovery?.estimation?.id,
            terminal: {
                idProduit: this.recovery?.criterias?.id,
                nom: this.recovery?.product?.name,
                marque: this.recovery?.product?.brand,
            },
            criteresQualification: [],
        };

        if (this.iban) {
            recoveryProduct.iban = this.iban;
        }

        // ESLint / Sonar ESLint: Expected an assignment or function call and instead saw an expression.(no-unused-expressions)
        const criteria: MobileRecoveryCritere[] = this.recovery?.estimation?.items?.criteresReprise || [];
        criteria.forEach((item) =>
            recoveryProduct.criteresQualification.push({
                critere: item.question,
                valeur: item.reponse.value === 'Oui',
            }),
        );

        return recoveryProduct;
    }

    public getAmount(quote: QuoteModel): number {
        const bonusAmount: number = this.hasBonus(quote) ? this.product.bonus : 0;
        return this.recovery?.estimation?.amount + bonusAmount || 0;
    }

    public hasBonus(quote: QuoteModel): boolean {
        const hasSensation: boolean = !!quote.getProductByType(Sensation);
        return hasSensation && !!this.product?.bonus;
    }

    public getProductLabel(): string {
        return `${this.recovery.product.brand} - ${this.recovery.product.name}`;
    }
}
